import apiKatsEstimate from "api/kats";
import { searchNestedIterableItem } from "core/iterable_utils";

const useNavigateToKatsViewerRow = ({ projectId, katsId, fetchStatusCallback }) => {
	const openKatsRowByNameCode = ({ code, name }) => {
		let katsMapping;
		apiKatsEstimate
			.getKatsMapper(projectId, code, name)
			.then((response) => {
				katsMapping = response.data;
				return response.data;
			})
			.then((data) => {
				return apiKatsEstimate.getTree(katsId);
			})
			.then((res) => {
				const tableData = res.data.table_data;
				const displayScrollTop = searchNestedIterableItem({
					iterable: tableData,
					isSeekRowCallback: (item) => {
						if (item.key && item.key === katsMapping[0].key) {
							return true;
						} else {
							return false;
						}
					},
					isPermittedRowCallback: () => true,
					isPermittedChildsLoopCallback: () => true,
				});

				localStorage.setItem("displayScrollTop", displayScrollTop.seekCount);
				localStorage.setItem("highlightRowClm", "code");
				localStorage.setItem("scrollKey", katsMapping[0].key);
				window.open(`/project/${projectId}/kats/${katsId}`);
			})
			.catch((error) => {
				console.error(error);
				window.open(`/project/${projectId}/kats/${katsId}`);
			});
	};

	const openKatsRowByResId = ({ resId }) => {
		if (fetchStatusCallback) fetchStatusCallback("loading");
		const seekKey = `KatsResources-${resId}`;
		apiKatsEstimate
			.getTree(katsId)
			.then((res) => {
				const tableData = res.data.table_data;
				const displayScrollTop = searchNestedIterableItem({
					iterable: tableData,
					isSeekRowCallback: (item) => {
						if (item.key && item.key === seekKey) {
							return true;
						} else {
							return false;
						}
					},
					isPermittedRowCallback: () => true,
					isPermittedChildsLoopCallback: () => true,
				});

				localStorage.setItem("displayScrollTop", displayScrollTop.seekCount);
				localStorage.setItem("highlightRowClm", "full_row");
				localStorage.setItem("scrollKey", seekKey);
				if (fetchStatusCallback) fetchStatusCallback("success");
				window.open(`/project/${projectId}/kats/${katsId}`);
			})
			.catch((error) => {
				console.error(error);
				if (fetchStatusCallback) fetchStatusCallback("failed");
				window.open(`/project/${projectId}/kats/${katsId}`);
			});
	};

	return { openKatsRowByNameCode, openKatsRowByResId };
};

export default useNavigateToKatsViewerRow;
